import type { GrantReservationAccessPayload } from '@massilia/contracts'

import { useMutation } from '@tanstack/react-query'

import { apiClient } from '../../lib/client.js'
import { writeReservationToken } from './reservation-token.js'

/**
 * Échange le nom de famille contre un jeton d'accès à la demande de
 * réservation. Le jeton est gardé pour la session : le client ne revérifie pas
 * à chaque navigation.
 */
export const useGrantReservationAccessMutation = () =>
  useMutation({
    mutationFn: async ({
      reservationId,
      ...payload
    }: GrantReservationAccessPayload & { reservationId: string }) => {
      const response = await apiClient.client.post<{ accessToken: string }>(
        `/public/reservations/${reservationId}/access`,
        payload
      )

      writeReservationToken(reservationId, response.data.accessToken)

      return response.data
    },
  })
